import {
  Button,
  Flex,
  Icon,
  Link,
  PlacementWithLogical,
  Text,
  Tooltip,
} from "@chakra-ui/react";
import { FaTimesCircle } from "react-icons/fa";
import { ProjectDocument } from "~/core/types";
import RequiredIndicator from "../RequiredIndicator";

export default function LikeRequirement({
  project,
  isTooltipOpen,
  tooltipPosition,
}: {
  project: ProjectDocument;
  isTooltipOpen: boolean;
  tooltipPosition?: PlacementWithLogical;
}) {
  return project?.twitter?.enabled && project?.twitter?.isLikeRequired ? (
    <Tooltip
      label={
        <>
          Please like{" "}
          <Link
            href={project?.twitter?.likeUrl}
            target={"_blank"}
            textDecoration={"underline"}
          >
            <b>this</b>
          </Link>{" "}
          on twitter.
        </>
      }
      pointerEvents={"all"}
      isOpen={isTooltipOpen}
      padding={4}
      fontSize={"md"}
      backgroundColor={"red.500"}
      placement={tooltipPosition}
      hasArrow
    >
      <Flex
        direction={"row"}
        alignItems={"center"}
        fontSize="13"
        color={"descText"}
        mb="2"
      >
        <Text>
          Like{" "}
          <Link
            href={project?.twitter?.likeUrl}
            target={"_blank"}
            color={"#2CBBDB"}
          >
            <b>this</b>
          </Link>{" "}
          on Twitter{" "}
          {isTooltipOpen && (
            <Text as={"span"}>
              <Icon as={FaTimesCircle} color="#CD4A38" />
            </Text>
          )}
        </Text>
        <RequiredIndicator required={!project.twitter.isLikeOptional} />
        <Button
          as={Link}
          target={"_blank"}
          href={project?.twitter?.likeUrl}
          ml={"auto"}
          size={"xs"}
          _hover={{ textDecoration: "none" }}
          px={4}
          py={4}
          colorScheme={"gray"}
          fontWeight={400}
          borderRadius={"3xl"}
        >
          <Text>Like</Text>
        </Button>
      </Flex>
    </Tooltip>
  ) : null;
}
